var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es480.js.map
